import React from "react";
import { useState, useEffect } from "react";
import { RxCounterClockwiseClock } from "react-icons/rx";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import DOMPurify from "dompurify";
import { Link } from "react-scroll";

import Arrow from "../../img/decor/arrow_down.png";

const EventProgram = ({ programData = [] }) => {

    const getTheme = (field) => {
        switch (field.acf_fc_layout) {
            case "panel_discussion":
                return field.theme_panell;

            case "panel_сollective":
                return field.theme_сollective;

            case "public_interview":
                return field.theme_interview;

            case "single_speacer":
                return field.theme;

            case "coffee_break":
                return field.break_title;

            default:
                return null;
        }
    };

    const SpeakerCard = ({speaker, speakerIndex,  badge, className = "", borderClass = "border-black", rounded = "", showPositionOutside = true,}) => (
        <div className={`speaker border p-4 ${borderClass} ${rounded} ${className}`}>
            <div className="flex items-start gap-3 mb-2">
                <div className={`speaker-foto w-20 shrink-0 overflow-hidden ${rounded}`}>
                    <img src={speaker.acf.sm_image}className="w-full h-full object-cover"alt={speaker.post_title} />
                    {badge && speakerIndex === 0 && (
                        <span className="bg-black text-white text-xs px-2 py-1 block">
                            {badge}
                        </span>
                    )}
                </div>

                <div className="speaker-info flex flex-col gap-2">
                    <h4 className="text-[14px]">{speaker.post_title}</h4>

                    {!showPositionOutside && (
                        <p className="text-[12px] text-[#333]">
                            {speaker.acf.position}
                        </p>
                    )}

                    {speaker.acf.logo && (
                        <img src={speaker.acf.logo} alt="" style={{ width: `${speaker.acf.logo_mw || 40}px` }}
                        />
                    )}
                </div>
            </div>

            {showPositionOutside && (
                <p className="text-[12px] text-[#333]">
                    {speaker.acf.position}
                </p>
            )}
        </div>
    );
    
    const accordionLayouts = [
        "panel_discussion",
        "panel_сollective",
        "public_interview",
    ];

    const [openPanel, setOpenPanel] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false); // Стан для розширення блоку
    
    const toggleSpeakersVisibility = () => {
        setIsExpanded(!isExpanded); // Перемикає стан "показати більше/менше"
    };

    useEffect(() => {
        if (openPanel !== null || !programData.length) return;
        for (let i = 0; i < programData.length; i++) {
            const fields = programData[i]?.acf?.program_fields || [];

            for (let j = 0; j < fields.length; j++) {
                const hasAccordion = fields[j].select_field?.some(field =>
                    accordionLayouts.includes(field.acf_fc_layout)
                );
                if (hasAccordion) {
                    setOpenPanel(`${i}-${j}`);
                    return;
                }
            }
        }
    }, [programData, openPanel]);

    return (
        <section className="mb-[60px] lg:mb-[120px]" id="programm">
            <div className="container max-w-screen-xl mx-auto pb-8 px-5">
                {programData.length > 0 ? (
                    <>
                        <div className={`overflow-hidden
                            ${!isExpanded ? "max-h-[930px] sm:max-h-[760px]" : "max-h-auto"}`}>

                            <h2 className="text-[30px] uppercase text-center font-bold xl:text-[55px] mb-7">Програма 2026</h2>
                            {/*<p className="text-center text-[#9c9c9c] font-medium mb-9">* Програма формується. Слідкуйте за оновленнями</p> */}
                            {programData.map((item, index) => {
                                return item.acf.program_fields.map((layoutData, subIndex) => {
                                    const { program_time, select_field } = layoutData;

                                    const isAccordion = select_field.some(field =>
                                        accordionLayouts.includes(field.acf_fc_layout)
                                    );

                                    const panelId = `${index}-${subIndex}`;
                                    const isOpen = openPanel === panelId;

                                    const headerContent = (
                                        <>
                                            <span className="flex md:mb-0 items-center gap-4 w-36 text-black font-medium">
                                                <RxCounterClockwiseClock className="text-black" />
                                                {program_time}
                                            </span>

                                            {select_field.map((field, fieldIndex) => {
                                                const theme = getTheme(field);

                                                return theme ? (
                                                    <h3
                                                        key={fieldIndex}
                                                        className="font-[inherit] font-normal text-black"
                                                        dangerouslySetInnerHTML={{
                                                            __html: DOMPurify.sanitize(theme),
                                                        }}
                                                    />
                                                ) : null;
                                            })}

                                            {isAccordion && (
                                                <span className={`ml-auto w-4 transition-transform duration-300 ${isOpen ? "rotate-180" : ""
                                                    }`}
                                                >
                                                    <img src={Arrow} alt="Arrow" />
                                                </span>
                                            )}
                                        </>
                                    );

                                    return (
                                        <div key={subIndex} className={`program-item p-3 ${subIndex % 2 == 0 ? 'bg-[#fff]' : ''}`}>
                                            {/** время и темы **/}
                                            {isAccordion ? (
                                                <button type="button" onClick={() => setOpenPanel(isOpen ? null : panelId)}
                                                    className="program-header flex w-full items-center gap-4 text-left"
                                                >
                                                    {headerContent}
                                                </button>
                                            ) : (
                                                <div className="program-header md:flex items-center gap-4">
                                                    {headerContent}
                                                </div>
                                            )}


                                            {/** Блоки **/}

                                            {isAccordion ? (
                                                <div className={`overflow-hidden transition-all duration-500 ${isOpen
                                                    ? "max-h-[5000px] opacity-100 pt-4"
                                                    : "max-h-0 opacity-0"}`} >
                                                    {select_field.map((field, fieldIndex) => {
                                                        switch (field.acf_fc_layout) {
                                                            case "panel_discussion":
                                                                return (
                                                                    <div key={fieldIndex}
                                                                        className="panel-discussion flex flex-col lg:flex-row-reverse py-4">
                                                                        <div
                                                                            className="thesises-panel font-normal lg:w-2/5 lg:mb-0 mb-4">
                                                                            <p className="text-justify text-[14px] thesis-list"
                                                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(field.thesises_panell, { sanitize: true }) }} />
                                                                        </div>
                                                                        <div className="speakers flex flex-col gap-2 flex-1 gap-5 md:flex-row md:flex-wrap">
                                                                            {field.speacers?.map((speaker, speakerIndex) => (
                                                                                <SpeakerCard
                                                                                    key={speakerIndex}
                                                                                    speaker={speaker}
                                                                                    speakerIndex={speakerIndex}
                                                                                    badge="Модератор"
                                                                                    className="md:w-[48%] xl:w-[31%]"
                                                                                    rounded=""
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            case "panel_сollective":
                                                                return (
                                                                    <div key={fieldIndex}
                                                                        className="panel-discussion flex flex-col lg:flex-row-reverse gap-7 py-4">
                                                                        <div
                                                                            className="thesises-panel font-normal lg:w-2/5 lg:mb-0 mb-4">
                                                                            <p className="text-justify text-[14px] thesis-list"
                                                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(field.thesises_сollective, { sanitize: true }) }} />

                                                                        </div>
                                                                        <div className="speakers flex-1 gap-5 md:flex md:flex-wrap">
                                                                            {field.speacers?.map((speaker, speakerIndex) => (
                                                                                <SpeakerCard
                                                                                    key={speakerIndex}
                                                                                    speaker={speaker}
                                                                                    speakerIndex={speakerIndex}
                                                                                    className=""
                                                                                    rounded=""
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            case "public_interview":
                                                                return (
                                                                    <div key={fieldIndex}
                                                                        className="panel-discussion flex flex-col lg:flex-row-reverse gap-7 py-4">
                                                                        <div
                                                                            className="thesises-panel font-normal lg:w-2/5 lg:mb-0 mb-4">
                                                                            <p className="text-justify text-[14px] thesis-list"
                                                                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(field.thesises_panell, { sanitize: true }) }} />

                                                                        </div>
                                                                        <div className="speakers flex-1 gap-5 md:flex md:flex-wrap">
                                                                            {field.speacers?.map((speaker, speakerIndex) => (
                                                                                <SpeakerCard
                                                                                    key={speakerIndex}
                                                                                    speaker={speaker}
                                                                                    speakerIndex={speakerIndex}
                                                                                    badge="Інтерв'юер"
                                                                                    horizontal
                                                                                    className=""
                                                                                    rounded=""
                                                                                />
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            default:
                                                                return null;
                                                        }
                                                    })}

                                                </div>

                                            ) : (
                                                <>
                                                    {select_field.map((field, fieldIndex) => {
                                                        switch (field.acf_fc_layout) {
                                                            case "single_speacer":
                                                                return (
                                                                    <div key={fieldIndex}
                                                                        className="single-speacer flex flex-col lg:flex-row gap-7 py-4">
                                                                        {field.speacer?.map((speaker, speakerIndex) => (
                                                                            <SpeakerCard
                                                                                key={speakerIndex}
                                                                                speaker={speaker}
                                                                                speakerIndex={speakerIndex}
                                                                                showPositionOutside={false}
                                                                                className=""
                                                                                rounded=""
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                );
                                                            default:
                                                                return null;
                                                        }
                                                    })}
                                                </>
                                            )}

                                        </div>

                                    );
                                });
                            })}

                        </div>
                    </>
                ) : (
                    <div className="text-center py-8">
                        <p className="text-gray-500">Програма завантажується...</p>
                    </div>
                )}

               {/* Кнопка "Показати більше" */}
                <div className="text-center mt-10">
                    <Link
                        to="programm"
                        smooth={true}
                        offset={-70}
                        duration={500}
                        onClick={toggleSpeakersVisibility} className="inline-block text-center bg-[#FED84A] text-black font-bold px-5 py-3 uppercase tracking-widest
                            hover:scale-105 transition-all duration-300 ease-out">
                        {isExpanded ? "Сховати" : "Повна програма"}
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default EventProgram;